export default "__VITE_ASSET__CbmlhQjG__"